import { API_G_050_HASSO_ANNAI_ENTRY } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_050: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getHassoAnnaiEntry(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_050_HASSO_ANNAI_ENTRY,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getHassoAnnaiEntry error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async getHassoAnnaiEntryItem(_ctx, params) {
      try {
        const {
          hatchuJigyoshoCd,
          hatchuEntryYmd,
          hatchuNo,
          hatchuShuseiCount,
        } = params;

        const res = await axios({
          url: `${API_G_050_HASSO_ANNAI_ENTRY}/${hatchuJigyoshoCd}/${hatchuEntryYmd}/${hatchuNo}/${hatchuShuseiCount}`,
          method: 'GET',
          params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getHassoAnnaiEntryItem error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async postHassoAnnaiEntry(_ctx, requestData) {
      try {
        const res = await axios({
          url: API_G_050_HASSO_ANNAI_ENTRY,
          data: {
            requestData,
          },
          method: 'POST',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api postHassoAnnaiEntry error.');
        console.log(err);
      }
    },
  },
};

export default g_050;
